// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How use it:
 * 1. by dispatch:
 *      dispatch({ type: "xHeader/update", data: { key: "isSticky", value: true } });
 *      data => it has "key" -> object key and value
 * 2. by handler:
 *      xHeaderUpdate({ key: "isSticky", value: true });
 */

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export type HeaderHandlerKey =
    | "isSticky"
    | "registerMenu"
    | "unregisterMenu"
    | "headerHeight"
    | "stickyHeader"
    | "showGlobalMessage"
    | "showSearchSectionOnMobile"
    | "secondaryNavigationHeaderHeight";

export type xHeaderHandlerType = {
    key?: HeaderHandlerKey;
    value: any;
};

export const DispatchUpdateHeader: Handler<xHeaderHandlerType> = props => {
    props.dispatch({
        type: "xHeader/update",
        data: props.parameter,
    } as any);
};

const xHeaderUpdate = createHandlerChainRunner([DispatchUpdateHeader], "xHeaderUpdate");
export default xHeaderUpdate;
